import { useEffect, useState } from "react"
import CalculateCard from "@/components/analysis/calculate/CalculateCard"
import ToolTips from "@/constants/ToolTips"
import { useEditAnalysis } from "@/queries/analysis"
import CalculatorItem from "@/components/calculate/CalculatorItem"
import { useStore } from "@nanostores/react"
import { currentStrategy } from "@/stores/strategyStore"
import { type AnalysisType } from "@/generated/graphql"
import * as AnalyzerEvents from "@/analytics/events/analyzer"

interface AdditionalCostsSectionProps {
  analysis: AnalysisType | null
}

const AdditionalCostsSection: React.FC<AdditionalCostsSectionProps> = ({
  analysis,
}: AdditionalCostsSectionProps) => {
  const strategy = useStore(currentStrategy)

  const [oneTimeCosts, setOneTimeCosts] = useState<number | null | undefined>()
  const [holdPeriod, setHoldPeriod] = useState<number | null | undefined>()
  const [holdingCosts, setHoldingCosts] = useState<number | null | undefined>()
  const editAnalysisMutation = useEditAnalysis()

  useEffect(() => {
    if (analysis) {
      setOneTimeCosts(analysis.oneTimeCosts)
      setHoldPeriod(analysis.holdPeriod)
      setHoldingCosts(analysis.holdingCosts)
    }
  }, [analysis])

  if (!analysis || strategy !== "Fix & Flip") {
    return null
  }

  const handleBlur = (title: string, value: number | null | undefined) => {
    AnalyzerEvents.analysisEditSubmitted({
      analysis,
      editedField: {
        fieldName: title,
        newValue: value,
      },
      fromScreen: "Subject Property Calculate",
      toScreen: "Subject Property Calculate",
    })
    editAnalysisMutation.mutate({
      analysisId: analysis?.id,
      analysisInput: {
        oneTimeCosts,
        holdPeriod,
        monthlyHoldingCosts: holdingCosts,
      },
    })
  }

  return (
    <CalculateCard title="Additional Costs">
      <CalculatorItem
        title="Other Project Costs"
        value={oneTimeCosts}
        tooltip={ToolTips.oneTimeCosts}
        onBlur={() => {
          handleBlur("Other Project Costs", oneTimeCosts)
        }}
        onValueChange={setOneTimeCosts}
      />
      <CalculatorItem
        title="Hold Period (mo)"
        value={holdPeriod}
        tooltip={ToolTips.holdPeriod}
        prefix=""
        // suffix=" mo"
        onBlur={() => {
          handleBlur("Hold Period", holdPeriod)
        }}
        onValueChange={setHoldPeriod}
      />
      <CalculatorItem
        title="Holding Costs ($/mo)"
        value={holdingCosts}
        tooltip={ToolTips.holdingCosts}
        // suffix="/mo"
        onBlur={() => {
          handleBlur("Holding Costs", holdingCosts)
        }}
        onValueChange={setHoldingCosts}
      />
    </CalculateCard>
  )
}

export default AdditionalCostsSection
